<template lang="pug">
EditableControl.input(:id="id" :displayValue="displayValue" :bus="bus" :editing="disabled ? false : editing" :editByDefault="editByDefault" :errors="errors" :navigationRoute="navigationRoute" :hrefLinkPrefix="hrefLinkPrefix")
  //- p value: {{ value }}
  //- p value_: {{ value_ }}
  //- p dirty: {{ dirty }}
  //- p displayValue: {{ displayValue }}

  input.form-control(
    :id='id + "_input"'
    :type='type'
    :value="value_"
    :placeholder='placeholder'
    :required='required'
    @focus="onFocus"
    @blur='onBlur'
    @keydown.enter.prevent='onEnter'
    @keydown.tab='onBlur'
    @input="onUpdate")
</template>

<script>
import { getRandom, Arrays } from "@gemma/utils";
import { GemmaError } from "@gemma/errors";
import { mixins } from "../EditableControl/mixins";
import { Events } from "../Block/index";
import "./scss";

export default {
  name: "Input",
  mixins: [mixins("value", { displayValue: ({ vm }) => vm.value_ || vm.emptyLabel })],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    emptyLabel: {
      type: String,
      default: "",
    },
    canBeEmpty: {
      type: Boolean,
      default: true,
    },
    setBus: {
      type: [Object, undefined],
      default: undefined,
    },
    valueMissingError: {
      type: Error,
      required: false,
      default: () => new GemmaError("Please supply a value", { ref: { type: "Input", id: "Missing" }, ui: true, sensitive: false, data: { fieldName: "input" } }),
    },
  },
  created() {
    if (this.setBus) {
      // debugger;
      this.setBus.bus = this.bus;
    }
    this.bus.$on(Events.Active, this.onActive);
    this.bus.$on(Events.ForceChange, this.onForceChange);
  },
  destroyed() {
    this.bus.$off(Events.Active, this.onActive);
    this.bus.$off(Events.ForceChange, this.onForceChange);
  },
  methods: {
    onBlur(event) {
      this.value_ = event.target.value;
      this.bus.$emit(Events.Active, { id: this.id, state: false, eventId: getRandom() });
    },
    onRefresh() {},
    onSaved({ id, errors }) {
      if (id === this.id && errors.length === 0) {
        this.$emit("input", this.value_);
      }
    },
    onUpdate(event) {
      this.value_ = event.target.value;
      this.bus.$emit(Events.Change, { id: this.id, value: this.value_ });
    },
    onForceChange() {
      this.displayValue = this.getDisplayValue("value_");
    },
    _onValidate({ value_ }) {
      if (!this.canBeEmpty && !value_.trim()) {
        Arrays.add(this.errors, this.valueMissingError);
        return false;
      }

      return true;
    },
  },
};
</script>
